import { IPoint } from "./Models";

export interface IPolygon {
  name: string;
  disableBoundingRectangle: boolean;
  preCalculatedArea: number;
  points: Array<IPoint> /* List */;
  linearRings: IPoint[][] /* List */;
  meanPoint: IPoint;
  firstPoint: IPoint;
  minimumPoint: IPoint;
  maximumPoint: IPoint;
  boundingRectangle: IPolygon;
  boxSize: number;
  needsSimplification: boolean;
  suggestedSimplificationTolerace: number;
  suggestedGridSpacing: number;
  isValid: boolean;
  isVeryLarge: boolean;
  isDFWSized: boolean;
  isComplex: boolean;
  isVerySmall: boolean;
}
